import { List, ListItem, ListItemText, Typography } from '@mui/material'
import { Switch } from 'utoniq-ui'

import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame, Template } from '@/core/architecture'

export * from './fragments'

export type State = {
  autoFollow: boolean
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onToggle: (autoFollow: boolean) => Promise<void>
}

export const AutoFollowSettingsTemplate: Template<State, Action> = ({
  state,
  onToggle,
}) => {
  const { t } = useTranslation('autoFollowSettings')
  const { routerNames, routerPages } = useRouter()
  return (
    <>
      <Head title={routerNames.AutoFollowSettings} />
      <BaseLayout
        header={{
          title: t('title'),
          back: true,
          defaultBackPage: routerPages.Setting,
        }}
      >
        <NoteCell />
        <List sx={{ bgcolor: 'grey.50' }}>
          <ListItem
            divider
            secondaryAction={
              <Switch
                checked={state.autoFollow}
                onChange={() => onToggle(!state.autoFollow)}
              />
            }
          >
            <ListItemText
              primaryTypographyProps={{ variant: 'body1' }}
              primary={t('autoFollow')}
            />
          </ListItem>
        </List>
      </BaseLayout>
    </>
  )
}

const NoteCell: Cell = () => {
  const { t } = useTranslation('autoFollowSettings')
  return (
    <CellFrame sx={{ px: 5, pt: 4, pb: 2 }}>
      <Typography variant="subtitle2" color="text.hint">
        {t('note')}
      </Typography>
    </CellFrame>
  )
}
